import React from 'react';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import './orderStatusTag.scss';
import { getCssVar } from 'utils/commonUtils';
import { OrderStatus } from 'types/dto/order';
import { OrderStatusObj } from 'constants/consts';

interface OrderStatusTagProps {
  status?: OrderStatus;
  statusName?: string;
  className?: string;
}

const OrderStatusTag: React.FC<OrderStatusTagProps> = ({
  status,
  statusName,
  className,
}) => {
  const { t } = useTranslation('order_history');

  const getMappedStatus = (status?: OrderStatus): OrderStatus | undefined => {
    if (status === OrderStatusObj.GLUS_UPDATED) {
      return OrderStatusObj.PROCESSING;
    }
    return status;
  };

  const getStatusColor = (status?: OrderStatus) => {
    const mappedStatus = getMappedStatus(status);
    switch (mappedStatus) {
      case OrderStatusObj.COMPLETED:
        return getCssVar('--primary-color');
      case OrderStatusObj.PROCESSING:
        return getCssVar('--vls-mid-yellow');
      case OrderStatusObj.REJECTED:
        return getCssVar('--vls-grey-light');
      case OrderStatusObj.CANCELLED:
        return getCssVar('--vls-grey-light');
      case OrderStatusObj.CANCELLED_BY_GLUS:
        return getCssVar('--vls-grey-light');
      case OrderStatusObj.EXPIRED:
        return getCssVar('--vls-red');
      case OrderStatusObj.RESERVED:
        return 'default';
      case OrderStatusObj.CONFIRMED:
        return 'default';
      default:
        return 'default';
    }
  };

  const getStatusTextClass = (status?: OrderStatus) => {
    const mappedStatus = getMappedStatus(status);
    return mappedStatus === OrderStatusObj.COMPLETED ||
      mappedStatus === OrderStatusObj.REJECTED
      ? 'tag-text-light'
      : 'tag-text-dark';
  };

  const getDisplayName = () => {
    if (status === OrderStatusObj.GLUS_UPDATED) {
      return t('processing');
    }
    return statusName;
  };

  const containerClass = className
    ? `order-status-tag-container ${className}`
    : 'order-status-tag-container';

  return (
    <div className={containerClass}>
      {(status === OrderStatusObj.GLUS_UPDATED || statusName) && (
        <Tag
          color={getStatusColor(status)}
          className={getStatusTextClass(status)}
        >
          {getDisplayName()}
        </Tag>
      )}
    </div>
  );
};

export default OrderStatusTag;